import { GET_RECURRING_BOOKINGS, RECURRING_BOOKING_RESPONSE_HANDLER } from "../actions/types";

export default (state = {}, action) => {
    let status = 400;
    let data = {}
    let notificationType = 'info'
    if (action.payload != undefined && typeof action.payload.status != 'undefined') {
        status = action.payload.status;
        notificationType = 'success'
        if (status >= 400) {
            notificationType = 'error'
        }
        data = action.payload.data;
    }

    let response = { notificationType: notificationType, type: action.type, status: status, action: 'LIST' };
    switch (action.type) {
        case GET_RECURRING_BOOKINGS:
            response['data'] = data.bookings;
            break;
        case RECURRING_BOOKING_RESPONSE_HANDLER:
            response['data'] = data;
            response['action'] = 'ACTION'
            break;
        default:
            return state;
    }
    return response
};
